import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';
import { FeaturesConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { ProductImageZoomModule } from '@spartacus/product/image-zoom';
import { ProductImageZoomComponentsModule } from '@spartacus/product/image-zoom/components';
import { ProductImageZoomRootModule } from '@spartacus/product/image-zoom/root';
import {
  CmsParagraphModule,
  IconModule,
  ItemCounterModule,
  MediaModule,
  OutletModule,
  PageLayoutModule,
  PageSlotModule,
  ProductAttributesModule,
  ProductDetailsTabModule,
  ProductImagesModule,
  ProductReviewsModule,
  ProductSummaryModule,
  TabParagraphContainerModule,
} from '@spartacus/storefront';
import { ProductImageZoomFeatureModule } from 'src/app/spartacus/features/product/product-image-zoom-feature.module';
import { CustomCxAddToCartComponent } from './custom-cx-add-to-cart/custom-cx-add-to-cart.component';
import { CustomProductImagesComponent } from './custom-product-images/custom-product-images.component';
import { CustomProductIntroComponent } from './custom-product-intro/custom-product-intro.component';
import { CustomProductSummaryComponent } from './custom-product-summary/custom-product-summary.component';
import { ZoomModule } from './zoom/zoom.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomCarouselItemComponent } from './custom-carousel-item/custom-carousel-item.component';
import { CustomCarouselComponent } from './custom-carousel/custom-carousel.component';

@NgModule({
  declarations: [
    CustomProductSummaryComponent,
    CustomProductIntroComponent,
    CustomProductImagesComponent,
    CustomCxAddToCartComponent,
    CustomCarouselItemComponent,
    CustomCarouselComponent
  ],
  imports: [
    CommonModule,
    MediaModule,
    ReactiveFormsModule,
    IconModule,
    ItemCounterModule,
    OutletModule,
    ProductSummaryModule,
    ProductImageZoomFeatureModule,
    ProductImageZoomModule,
    ProductImageZoomRootModule,
    ProductImagesModule,
    ProductImageZoomComponentsModule,
    AddToCartModule,
    ProductAttributesModule,
    ProductReviewsModule,
    CmsParagraphModule,
    I18nModule,
    ProductDetailsTabModule,
    TabParagraphContainerModule,
    PageSlotModule,
    PageLayoutModule,
    ZoomModule,
    RouterModule,
    UrlModule,
    FeaturesConfigModule
  ],
  exports: [
    // CustomProductSummaryComponent,
    // CustomProductIntroComponent,
    // CustomProductImagesComponent,
    // CustomCarouselItemComponent
  ],
})
export class ComponentsModule {}
